export const eventsQueryKeys = {
  all: ['events'] as const,
  portal: (locationId?: string, contactId?: string) => ['events', 'portal', locationId, contactId] as const,
  portalDirectory: (state?: string, locationId?: string, contactId?: string) =>
    ['events', 'portalDirectory', state, locationId, contactId] as const,
  detail: (eventId?: string) => ['events', 'detail', eventId] as const,
  schedule: (eventId?: string, contactId?: string) => ['events', 'schedule', eventId, contactId] as const,
  scheduleBySpeaker: (eventId?: string, contactId?: string, speakerId?: string) =>
    ['events', 'scheduleBySpeaker', eventId, contactId, speakerId] as const,
  speakers: (eventId?: string) => ['events', 'speakers', eventId] as const,
  attendees: (eventId?: string) => ['events', 'attendees', eventId] as const,
  attendeesByContact: (eventId?: string, contactId?: string, locationId?: string) =>
    ['events', 'attendeesByContact', eventId, contactId, locationId] as const,
  exhibitors: (eventId?: string, locationId?: string) => ['events', 'exhibitors', eventId, locationId] as const,
  exhibitorMembers: (eventId?: string, exhibitorId?: string, locationId?: string) =>
    ['events', 'exhibitorMembers', eventId, exhibitorId, locationId] as const,
} as const
